<template>
    <div >   
        <!-- //DIALOGS -->
        <div>
            <!-- STEP1 TRANSFER SELECTED ITEMS STOCKS -->
            <v-dialog
                v-model="dialog_transfer_select_items"
                scrollable   
                :persistent="false" :overlay="false"
                max-width="900px"
                transition="dialog-transition" >
                <form id="itemDetailForm" @submit.prevent="CONTINUE_STOCK_TRANSFER()" >
                    <v-card rounded="lg" >
                        <v-card-title class="primary">
                            <v-layout row wrap   align-center  class="pt-2 px-5">
                                <div class="font-weight-bold b2--text">
                                    <v-icon dark large>mdi-transfer</v-icon> TRANSFER STOCK
                                </div> 
                                <v-autocomplete   class="ml-2 mt-" dark  
                                    :label="'Search item'" 
                                    append-icon="mdi-magnify" 
                                    clearable 
                                    filled
                                    rounded :disabled="false"
                                    :items="InventoryItems"
                                    :item-text="'name'"
                                    item-value="key"
                                    outlined
                                    v-model="search_item"
                                    :filter="(item, queryText, itemText) => { 
                                        let index = (a,b)=>{
                                                if(!a||!b){return false}
                                                a = ''+a; b = ''+b
                                                return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                                            } 
                                            let first = index(itemText,queryText)
                                            let second = item?index(item.code,queryText):false
                                            let third = item?index(item.brand_name,queryText):false
                                            let forth = item?index(item.category_name,queryText):false
                                            if(!item){return first}  
                                            return first || second || third || forth 
                                    }"
                                    >
                                    <template v-slot:selection="data">
                                        {{ data.item.name }}
                                    </template>
                                    <template v-slot:item="data">
                                        <template v-if="(typeof data.item !=='object')" >
                                            <v-list-item-content v-text="data.item"></v-list-item-content>
                                        </template>
                                        <template v-else>
                                            <v-list-item-avatar tile color="grey" >
                                                <img :src="data.item.image" v-if="data.item.image">
                                                <v-icon v-else>local_offer</v-icon>
                                            </v-list-item-avatar>
                                            <v-list-item-content >
                                                <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                                <v-list-item-subtitle v-html="data.item.code_"></v-list-item-subtitle>
                                                <v-list-item-subtitle v-html="data.item.category_name"></v-list-item-subtitle>
                                                <v-list-item-subtitle v-html="data.item.brand_name"></v-list-item-subtitle>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <div class=" font-weight-bold"> 
                                                    <small> Stock</small> {{data.item[from_outlet_code+"_number_quantity"]}}
                                                </div> 
                                            </v-list-item-action> 
                                        </template>
                                    </template>
                                </v-autocomplete>  
                                <v-spacer></v-spacer>
                                <v-btn v-if="selected_items" class="mr-2" tile small color="secondary" @click="CONFIRM_CLEAR_SELECTED_ITEMS()">
                                    Clear
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                                <v-btn dark icon @click="dialog_transfer_select_items = false"><v-icon>mdi-close</v-icon></v-btn>
                                
                            </v-layout>
                        </v-card-title>
                        <v-card flat class="mbs-scroll-" >
                            <v-card outlined class="ma-5">
                                 <mbs-stock-transfer-selected-items
                                        v-model="input_transfer"
                                        :height="(vsh-295)" 
                                        :outlet_code="from_outlet_code"  
                                    />
                            </v-card> 
                        </v-card> 
                        <v-divider class="mt-"></v-divider>
                        <v-card-actions>
                            <v-layout  class="ma-0" align-center> 
                                <v-flex xs3> 
                                    <v-btn @click="dialog_transfer_select_items = false" large color="secondary"   width="100%" class="px-5 ml-">CANCEL</v-btn>
                                </v-flex>
                                <v-flex> 
                                    <v-btn   type="submit"  
                                    class="px- ml-1" large color="primary" width="100%" >CONTINUE</v-btn>
                                </v-flex> 
                            </v-layout>
                        </v-card-actions> 
                    </v-card> 
                </form>
            </v-dialog>

             <!-- STEP2 TRANSFER STOCKS -->
            <v-dialog
                v-model="dialog_transfer_stocks"
                scrollable   
                :persistent="false" :overlay="false"
                max-width="900px"
                transition="dialog-transition" >
                <form id="itemDetailForm" @submit.prevent="CONFIRM_STOCK_TRANSFER(input,transfer_option)" >
                    <v-card rounded="lg" v-if="dialog_transfer_stocks">
                        <v-card-title class="primary">
                            <div class="font-weight-bold b2--text"><v-icon dark large>mdi-transfer</v-icon> TRANSFER STOCK(S)</div> 
                            <v-spacer></v-spacer>
                            <v-btn dark icon @click="dialog_transfer_stocks = false"><v-icon>mdi-close</v-icon></v-btn>
                        </v-card-title>
                        <v-card flat class="mbs-scroll-y" :height="''">
                            <v-card outlined class="ma-5">
                                <v-list-item @click="BACK_STOCK_TRANSFER()">
                                    <v-list-item-action>
                                        <v-icon>mdi-tag</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>{{input_transfer?.item_size}} Selected items</v-list-item-title>
                                        <v-list-item-subtitle>{{ input_transfer?.quantity }}</v-list-item-subtitle>
        
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        Cost {{ input_transfer?.cost_price }}
                                    </v-list-item-action>
                                </v-list-item> 
                            </v-card>
                            <v-card outlined class="mx-5 pa-5">
                                <mbs-input-fields
                                    v-model="input"
                                    :name_items="NAME_ITEMS"
                                    :name_item="NAME_ITEM"
                                    :value_items="VALUE_ITEMS"
                                    :value_item="VALUE_ITEM"
                                    :field_items="DATA.FIELDS.transfer_selected_stocks"
                                    :select_items="Selectors"
                                    :disabled_fields="null"
                                    />    
                            </v-card>
                            
                        </v-card> 
                        <v-divider class="mt-2"></v-divider>
                        <v-card-actions>
                            <v-layout  class="ma-0" align-center> 
                                <v-flex> 
                                    <v-btn    @click="SUBMIT_SOCK_TRANSFER('send_for_approval')"
                                    class="px- m" large color="primary" width="100%" >SEND FOR APPROVAL</v-btn>
                                </v-flex> 
                                <v-flex xs3> 
                                    <v-menu  
                                        v-model="menu_transfer_option" 
                                        :close-on-content-click="false" 
                                        offset-y  offset-overflow
                                        :nudge-width="90" rounded="xl">

                                        <template v-slot:activator="{ on }">   
                                             
                                            <v-btn large  v-show="false" type="submit"
                                                :loading="inputLoading" ref="ref_btn_transfer_stock"
                                                class="mt-3 "  color="secondary" height="60" width="99%">
                                                <div class="not-f5">Transfer Options</div>  
                                                <v-icon class="ml-1 mr-1">arrow_drop_down</v-icon>
                                            </v-btn> 
                                            <v-btn large  v-on="on"
                                                :loading="inputLoading" 
                                                class="ml-1 "  color="secondary" width="99%">
                                                <div class="not-f5">Transfer Options</div>  
                                                <v-icon class="ml-1 mr-1">arrow_drop_down</v-icon>
                                            </v-btn> 
                                        </template>  
                                        <v-card>
                                            <v-card-title primary-title class="secondary white--text">
                                                Transfer Option
                                            </v-card-title>
                                            <v-list>
                                                <v-list-item @click="SUBMIT_SOCK_TRANSFER('direct_transfer')">
                                                    Direct Transfer
                                                </v-list-item> 
                                                <v-list-item  @click="SUBMIT_SOCK_TRANSFER('send_for_verification')">
                                                    Send for Verification
                                                </v-list-item>
                                                <v-list-item @click="SUBMIT_SOCK_TRANSFER('save_draft')">
                                                    Save Draft
                                                </v-list-item> 
                                            </v-list>
                                        </v-card>
                                    </v-menu>  
                                </v-flex>
                            </v-layout>
                        </v-card-actions> 
                    </v-card> 
                </form>
            </v-dialog>
            
             
              
        </div>
    </div>
</template> 
<script> 

    import DATA from "../../../plugins/DATA";
    import {mapState} from "vuex" 
    import DB from "../../../plugins/DB";
    const PAGE_NAME = "SELECT_ITEMS"

    export default {
        props:['from_outlet_code','to_outlet_code','outlets','items',],
        data(){
            return{
                show:false,   
                dialog_transfer_stocks:false,   
                dialog_transfer_select_items:false,   
                dialog_receive_stock_option:false,   
                menu_transfer_option:false,  
                inputLoading:false,
                search_item:null,
                selected_item:null,
                selected_items:null,
                transfer_option:null, 
                input:{}, 
                input_transfer:{}, 
                DATA,
                NAME_ITEMS:DATA.ITEMS.ITEMS.names,
                NAME_ITEM:DATA.ITEMS.ITEMS.name,
                VALUE_ITEMS:DATA.ITEMS.ITEMS.values,
                VALUE_ITEM:DATA.ITEMS.ITEMS.value, 
            }
        },
        created(){ 
            try {
                this.MBS.events.$on('DIALOG_YES', this.DIALOG_YES);   
                this.MBS.events.$on('ON_QR_SCAN', this.ON_QR_SCAN);   
                this.MBS.events.$on('MBS_KEYBOARD', this.MBS_KEYBOARD);  
                this.MBS.events.$on('INVENTORY_STOCK_TRANSFER', this.INVENTORY_STOCK_TRANSFER);  
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:PAGE_NAME, 
                }) 
            }
        },
        mounted(){   
        },
        computed:{
            vs(){
                let vs = this.$vuetify.breakpoint 
                return vs
            }, 
            vs_width(){
                let vs = this.vs
                if(!vs){return null}
                return vs.width
            },
            vsh(){
                return this.vs.height
            },
            ...mapState({
                loading:state=>state.load.loading,
                processes:state=>state.load.processes,
                responses:state=>state.load.responses,
            }),
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
                SELECTED_COMPANY: state=> state.items['SELECTED_COMPANY'], 
            }),
            ...mapState({
                CompanySettings: state=> state.items[(DATA.ITEMS.COMPANY_SETTINGS.values).toUpperCase()], 
                CompanyQuickActions: state=> state.items[(DATA.ITEMS.COMPANY_QUICK_ACTIONS.values).toUpperCase()], 
                Items: state=> state.items[(DATA.ITEMS.ITEMS.values).toUpperCase()],
                JoinedItems: state=> state.join[(DATA.ITEMS.ITEMS.values).toUpperCase()], 
                ItemCategories: state=> state.items[(DATA.ITEMS.ITEM_CATEGORIES.values).toUpperCase()],
                
                StockOutlets: state=> state.items[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()],
                JoinedStockOutlets: state=> state.join[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()],  
            }), 
            StockOutletsData(){ 
                let items = this.JoinedStockOutlets?this.JoinedStockOutlets:this.StockOutlets 
                return items
            }, 
            ToOutlets(){
                const outlets = this.StockOutlets
                const outlet_code = this.from_outlet_code
                return outlets?.filter(item=>item.code !=outlet_code)
            },
            ItemsData(){ 
                let Items = this.Items
                let JoinedItems = this.JoinedItems
                let CalculatedItems = this.CalculatedItems 
                if (JoinedItems) {
                    return JoinedItems
                } 
                return Items
            },
            InventoryItems(){ 
                const items = this.ItemsData 
                const filtered = items?.filter(item=>{
                    const service = item.item_type_key == "service"
                    const child = item.item_type_key == "child"
                    const parent = item.item_type_key == "parent"
                    const inventory_item_code = item?.inventory_item_code
                    const inventory_item_key = item?.inventory_item_key
                    const inventory_item_keycode = inventory_item_key?inventory_item_key:inventory_item_code
                    const inventory = !inventory_item_keycode || inventory_item_keycode == "main"?true:false
                    return inventory && !service && !child && !parent
                })  
                return filtered
            },

            Selectors(){ 
                let Outlets = this.StockOutletsData 
                let ToOutlets = this.ToOutlets 
                let Items = this.ItemsData  
                let ItemCategories = this.ItemCategories 

                console.log(Outlets,"Outlets....1-.");
                
                return{
                    Outlets: Outlets,
                    ToOutlets: ToOutlets,
                    Items: Items,
                    ItemCategories: ItemCategories, 
                }
            }, 
        },
        methods:{ 
            async INVENTORY_STOCK_TRANSFER(payload){
                try {  
                    this.dialog_transfer_select_items = true
                    if (payload?.item_key !=undefined || payload?.item_code !=undefined  ) { 
                        this.ADD_ITEM(payload.item_key,payload.item_code)
                    }
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'INVENTORY_STOCK_TRANSFER',
                        page:PAGE_NAME, 
                    }) 
                }
            },
            async ADD_ITEM(item_key, item_code){
                try { 

                    console.log(item_key,item_code,); 
                    const settings = this.CompanySettings 
                    const activate_stock_level = settings?settings.activate_stock_level:null 

 
                    const outlet_code = this.stock_outlet_code
                    let quantity = null
                    let item_price = null 
                    let scales = this.Scales  
                    
                    const items = this.ItemsData 
                    const moment = this.MBS.date.moment
                    const selecting_list_key = moment?moment().valueOf():null

                    
                    
                    if (items) {
                        setTimeout(() => {
                            this.search_item=null 
                        }, 500);
                        let item_selected = items.find(item=>{
                            return  item_key?item.key == item_key:item.code == item_code
                        }) 
                        if (!item_selected) {
                            this.MBS.actions.dialog()
                            let isTimestamp = this.MBS.actions.isTimestamp(item_code)
                            if(isTimestamp){ 
                                console.log(item_code,'isTimestamp...')
                            }else{
                            }
                            setTimeout(() => {    
                                this.MBS.actions.dialogConfirmPassword({
                                    show:true,
                                    icon:mdiTagHidden,
                                    title:'ITEM NOT FOUND',
                                    text:"Item (" + item_code + ") not found. Please ensure that items are loaded and refreshed. Alternatively, you can use scanned barcode to add the item as new.",
                                    btnYes:"ADD AS NEW ITEM",
                                    btnNo:"REFRESH ITEMS",
                                    action:{
                                        code:PAGE_NAME+'=CREATE_AS_NEW_ITEM',
                                        item_code:item_code,
                                        silent_btn_no:true,
                                        phone_number_start:true,
                                        all_users:true,
                                        get_access:{
                                            permission_type:"action", 
                                            permission_to:"write", 
                                            action_name:DATA.ITEMS.ITEMS.names
                                        }
                                    }
                                }) 
                            }, 500); 
                            return 
                        } 
                        
                        //check stock level
                        if (activate_stock_level) {
                            
                            let stock_settings = await this.MBS.actions.CHECK_ITEM_STOCK_SETTINGS({
                                item:item_selected,
                                outlet_code:outlet_code,
                                notify:false
                            })

                            // console.log(stock_settings,'stock_settings-*---------------****');
                            
  
                            let allow_sell = stock_settings?stock_settings.allow_sell:null 
                            let stop_selling_level = stock_settings?stock_settings.stop_selling_level:null 
                            let quantity = stock_settings?stock_settings.quantity:null 
                            let stop_sale = quantity <= stop_selling_level?true:false
                            if (!allow_sell && stop_sale) {
                                await this.MBS.actions.CHECK_ITEM_STOCK_SETTINGS({
                                    item:item_selected,
                                    outlet_code:outlet_code,
                                    notify:true
                                })
                                return
                            } 
                        }


                        /// if array
                        let newItem = {
                            ...item_selected,  
                            quantity:quantity?quantity:1,
                        }

                       
                        console.log(newItem,'newItem......');

                        //display selected item
                        // this.CUSTOMER_DISPLAY({
                        //     type:'add_item',
                        //     item:newItem
                        // }) 

                        this.MBS.events.$emit("ADD_STOCK_TRANSFER_SELECTED_ITEMS",{
                            item_key:item_key,
                            item_code:item_code,  
                            selected_item:newItem,
                        }) 
                        return 
                    }
                     
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ADD_ITEM',
                        page:PAGE_NAME, 
                    }) 
                }
            },
            CONFIRM_CLEAR_SELECTED_ITEMS(){
                try {    
                    
                    let mbs_text = this.MBS.text.item_action("Selected Items","Clear") 
                    this.MBS.actions.dialog({
                        show:true,
                        fixed:true,
                        icon:"mdi-delete",
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes,
                        btnNo:mbs_text.btnNo,
                        action:{
                            code:PAGE_NAME+'=CLEAR-SELECTED-ITEMS', 
                            show_response:true
                        }
                    })   
                     
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CONFIRM_CLEAR_SELECTED_ITEMS',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            CLEAR_SELECTED_ITEMS(show_response){
                try {   
                    DB.deleteItems({
                        name:DATA.ITEMS.LOCAL_SELECTED_STOCK_ADJUSTMENTS.values, 
                        update_locals:true, 
                    }).then(res=>{
                        console.log(res,'res........');
                        this.MBS.actions.progressDialog()
                        if (show_response) {
                            let mbs_text = this.MBS.text.item_action_success("Selected Items","Clearing")
                            this.MBS.actions.dialog({
                                show:true,
                                title:mbs_text.title,
                                text:mbs_text.text,
                                btnYes:mbs_text.btnYes,
                                btnNo:mbs_text.btnNo, 
                            })     
                        }
                    }).catch(error=>{
                        console.log(error,'error...........');
                        this.MBS.actions.progressDialog()
                        if (show_response) {
                            let mbs_text = this.MBS.text.item_action_fail("Selected Items","Clearing")
                            this.MBS.actions.dialog({
                                show:true,
                                title:mbs_text.title,
                                text:mbs_text.text,
                                btnYes:mbs_text.btnYes,
                                btnNo:mbs_text.btnNo, 
                            }) 
                        }
                    })
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CONFIRM_CLEAR_SELECTED_ITEMS',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            CONTINUE_STOCK_TRANSFER(){
                try {  
                    this.input.from_outlet_code = this.from_outlet_code? this.from_outlet_code:null,
                    this.input.selected_items = this.selected_items? this.selected_items:null
                    this.dialog_transfer_select_items = false
                    this.dialog_transfer_stocks = true  
                    // setTimeout(() => {
                    // }, 100);
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CONTINUE_STOCK_TRANSFER',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            BACK_STOCK_TRANSFER(){
                try {   
                    this.dialog_transfer_select_items = true
                    this.dialog_transfer_stocks = false   
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'BACK_STOCK_TRANSFER',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            SUBMIT_SOCK_TRANSFER(option){ 
                try { 
                    this.menu_transfer_option = false
                    this.transfer_option = option 
                    this.$refs.ref_btn_transfer_stock.$el.click();
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'SEND_AND_PRINT_NEW_ORDER',
                        page:PAGE_NAME, 
                    }) 
                }
            },
            CONFIRM_STOCK_TRANSFER(input,transfer_option){
                try {    
                    const ud = this.ud
                    const uid = ud?.uid
                    const company = this.selectedCompany
                    const company_key = company?.company_key
                    const moment = this.MBS.date.moment
                    const key = moment?moment().valueOf():null
                    const code = input?.code?input?.code:null
                    const from_outlet_code = input?.from_outlet_code?input?.from_outlet_code:null
                    const to_outlet_code = input?.to_outlet_code?input?.to_outlet_code:null
                    const transferred_date = input?.transferred_date?input?.transferred_date:null
                    const description = input?.description?input?.description:null
                    const selected_items = input?.selected_items?input?.selected_items:null
                    let dialog = this.MBS.actions.dialog
                    let items = []
                    let mbs_text = null
                    let error_text = null
                    selected_items?.forEach(item => {
                        items.push({
                            item_key:item._key,
                            item_code:item._code,
                            item_name:item.name,
                            item_cost_price:item.cost_price,
                            quantity:item.quantity, 
                            
                        })
                        
                    });
                    const data = {
                        order_type:DATA.ITEMS.STOCK_TRANSFERS.value,
                        code,from_outlet_code,
                        to_outlet_code,transferred_date,
                        description,items,
                        created_uid:uid,
                        company_key,
                        local_created_at:key,
                        transfer_option
                    }
                    if (from_outlet_code == to_outlet_code) {
                        error_text = 'Transfer to outlet should be different from Transfer from outlet. '
                    }

                    if (transfer_option == "send_for_approval") {
                        dialog = this.MBS.actions.dialogConfirmPassword
                        mbs_text = this.MBS.text.item_action("Stock Transfer for approval","Send") 
                    }else if (transfer_option == "direct_transfer") {
                        dialog = this.MBS.actions.dialogConfirmPassword
                        mbs_text = this.MBS.text.item_action("Stock","Direct Transfer") 
                    }else if (transfer_option == "send_for_verification") {
                        dialog = this.MBS.actions.dialogConfirmPassword
                        mbs_text = this.MBS.text.item_action("Stock Transfer for verification","send") 
                    }else if (transfer_option == "save_draft") {
                        mbs_text = this.MBS.text.item_action("Draft","Save") 
                    }else{
                        error_text = "Something went wrong. Please try again."
                    } 

                    if (error_text) {
                        this.MBS.actions.dialog({
                            show:true,
                            fixed:true,
                            icon:"mdi-alert",
                            title:"ERROR",
                            text:error_text,
                            btnYes:"OKAY", 
                        })  
                        return 
                    }

                    console.log(input,'input..............');
                    console.log(data,'data..............XXX');
 
                    dialog({
                        show:true,
                        fixed:true,
                        icon:"mdi-transfer",
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes,
                        btnNo:mbs_text.btnNo,
                        action:{
                            code:PAGE_NAME+'=SUBMIT-TRANSFER-STOCK', 
                            data,
                            phone_number_start:true,
                            all_users:true,
                            get_access:{
                                permission_type:"action", 
                                permission_to:"inventory", 
                                action_name:DATA.ITEMS.STOCK_TRANSFERS.names
                            }
                        }
                    })   
                     
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CONFIRM_STOCK_TRANSFER',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            SUBMIT_TRANSFER_ORDER(order,action){
                try {  
                    const order_code = order?.code
                    const uid = action?.ud?.uid
                    const transfer_option = order?.transfer_option 
                    let path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.stock_drafts+order_code,true) 
                    if (transfer_option =="send_for_approval") {
                        path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.stock_requests+order_code,true)
                    }if (transfer_option =="send_for_verification") {
                        path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.stock_requests+order_code,true)
                    }if (transfer_option =="direct_transfer") {
                        path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.stock_orders+order_code,true)
                    }
                    if (uid) {
                        order.logged_uid = order.created_uid
                        order.created_uid = uid
                    }
                    if (!order_code || !path) {
                        console.log(order,'order error');
                    } 
                     console.log(path,'path------------**');
                     console.log(action,'action------------**');
                     console.log(order,'order------------**');
                     
                    this.inputLoading = true
                    this.MBS.actions.progressDialog({
                        show:true,
                        title:"Uploading..",
                    }) 
                    this.$store.dispatch("fi_update",{
                        action:DATA.ITEMS.STOCK_ORDERS.values,
                        data:order,
                        path:path
                    })
                    .then(res=>{
                        console.log(res,'re..................');
                        return  this.$store.dispatch('fi_tracker',{
                            company:this.selectedCompany,
                            names:[
                                {data_save:false,on:false,get:false,cash:true,name:DATA.ITEMS.ITEMS.values}, 
                            ]
                        }) 
                    })
                    .then(res=>{
                        this.inputLoading = false
                        this.dialog_transfer_select_items = false
                        this.dialog_transfer_stocks = false
                        this.MBS.actions.progressDialog() 
                        this.CLEAR_SELECTED_ITEMS()
                        let mbs_text = this.MBS.text.item_action_success(DATA.ITEMS.STOCKS.value,"Transferring")
                        this.MBS.actions.dialog({
                            show:true,
                            fixed:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes, 
                        })   
                        console.log(res,'re..................s');
                         
                    }).catch(error=>{
                        console.log(error,'err..................');
                        this.MBS.actions.progressDialog() 
                        this.MBS.actions.error({
                            error:error,
                            from:'SUBMIT_ORDER',
                            page:PAGE_NAME, 
                        })  
                        this.inputLoading = false
                        this.MBS.actions.progressDialog() 
                        let mbs_text = this.MBS.text.item_action_fail(DATA.ITEMS.STOCKS.value,"Transferring")
                        this.MBS.actions.dialog({
                            show:true,
                            fixed:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes, 
                        })  
                    }) 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'SUBMIT_TRANSFER_ORDER',
                        page:PAGE_NAME, 
                    }) 
                }
                
            },
            
            

            //---------------[MAIN FUNCTIONS]------------   
            DIALOG_YES(action){ 
                try {
                    if (action.code) { 
                        if (action.code ===PAGE_NAME+'=CLEAR-SELECTED-ITEMS') {
                            if (action.YES) {
                                this.CLEAR_SELECTED_ITEMS(action.show_response)
                            } else {
                                
                            }
                        } if (action.code ===PAGE_NAME+'=SUBMIT-TRANSFER-STOCK') {
                            if (action.YES) {
                                this.SUBMIT_TRANSFER_ORDER(action.data,action)
                            } else {
                                
                            }
                        }  
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'DIALOG_YES',
                        page:PAGE_NAME, 
                    }) 
                }  
            },  
            ON_QR_SCAN(code){
                try {
                    if (code) {  
                        
                        let size = this.MBS.actions.SIZE(code)
                        if (size<3) { 
                        }else{  
                             
                        }
                    }
                } catch (error) {
                    console.log(error,'.............................');
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_QR_SCAN',
                        page:PAGE_NAME, 
                    })  
                } 
            },
            MBS_KEYBOARD(key){ 
                let focused_field = this.focused_field
                const field_value = focused_field?focused_field.value:null

                const ref_inputs = this.$refs
                if (key ) {
                    let value = key.value 
                    if (field_value) { 
                        if (field_value == "current_selected_item_quantity") {
                            if (value=="BACK_SPACE") {
                                this.current_selected_item.quantity = (""+this.current_selected_item.quantity).slice(0,-1)
                            } else {
                                this.current_selected_item.quantity =this.current_selected_item.quantity+""+value 
                            }
                        }else if (field_value == "current_selected_item_discount") {
                            if (value=="BACK_SPACE") {
                                this.current_selected_item.discount = (""+this.current_selected_item.discount).slice(0,-1)
                            } else {
                                this.current_selected_item.discount =this.current_selected_item.discount+""+value 
                            }
                        }else{
                            if(!this.input){this.input={}}
                            if (value=="BACK_SPACE") {
                                this.input[field_value] =(this.input[field_value]?this.input[field_value]+'':'').slice(0,-1)
                            }else{
                                this.input[field_value] =(this.input[field_value]?this.input[field_value]:'')+value
                                console.log((this.input[field_value]?this.input[field_value]:'')+value,'****......');
                            }
                            setTimeout(() => {
                                this.input = {...this.input}
                            }, 1);

                            console.log(this.input,'input......');
                            console.log(value,'value......');
                        }
                        
                    }
                }
            }, 
        },
        beforeDestroy(){
            try {
                this.MBS.events.$off('DIALOG_YES', this.DIALOG_YES);  
                this.MBS.events.$off('ON_QR_SCAN', this.ON_QR_SCAN);  
                this.MBS.events.$off('MBS_KEYBOARD', this.MBS_KEYBOARD);        
                this.MBS.events.$off('INVENTORY_STOCK_TRANSFER', this.INVENTORY_STOCK_TRANSFER);        
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'beforeDestroy',
                    page:PAGE_NAME, 
                })
            }
        },
        watch:{ 
            item_multiple_select(value){
                this.$emit("item_multiple_select",value?true:false)
            },  
            input_transfer(value){
                this.selected_items = value?.selected_items
                console.log(value,'value................'); 
            }, 
        } 

    }
</script>
<style>
    .selected {
        background-color: #a8dadc;
    }
    .checked {
        background-color: #dadada;
    }
    
</style> 